import { render, staticRenderFns } from "./CreateCompanyStepTwo.vue?vue&type=template&id=7aa448a1"
import script from "./CreateCompanyStepTwo.vue?vue&type=script&lang=js"
export * from "./CreateCompanyStepTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports